import Swiper from 'swiper';
import { Pagination, Navigation, EffectFade } from 'swiper/modules';

class PageHome {
  private container: HTMLElement | null;
  constructor() {
    this.container = document.querySelector('.page-template-tpl-home')

    if (!this.container)
      return
    this._homeSwipers();
    this._scrollTo();
  }

  _homeSwipers() {
    new Swiper('.page-home-heading__swiper', {
      modules: [Pagination, Navigation, EffectFade],
      direction: 'horizontal',
      slidesPerView: 1,
      spaceBetween: 0,
      effect: 'fade',
      loop: true,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
    });
    new Swiper('.page-home-realisations__swiper', {
      modules: [Pagination, Navigation, EffectFade],
      direction: 'horizontal',
      slidesPerView: 1,
      spaceBetween: 0,
      effect: 'fade',
      loop: true,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
    });
  }

  _scrollTo() {
    const scrollButton = this.container?.querySelector<HTMLButtonElement>('[data-page-home-scroll-to]');
    const header = document.querySelector<HTMLElement>('header'); // Adaptez ce sélecteur si besoin

    if (!scrollButton || !header) {
      return;
    }

    scrollButton.addEventListener('click', (event) => {
      event.preventDefault();

      const targetSection = this.container?.querySelector<HTMLElement>('.listing-aides');
      if (!targetSection) return;

      const headerHeight = header.offsetHeight;
      const targetPosition = targetSection.getBoundingClientRect().top + window.scrollY;
      const scrollTargetY = targetPosition - headerHeight;

      window.scrollTo({
        top: scrollTargetY,
        behavior: 'smooth'
      });
    });
  }
}

export const pageHome = new PageHome();
